import React from 'react';

export class PlusIcon extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <svg viewBox="20.5 20.5 23 23">
                <g transform="translate(21.000000, 21.000000)">
                    <path d="M12.2222222,9.27777778 L12.2222222,0 L7.77777778,0 L7.77777778,9.27777778 L-1.5,9.27777778 L-1.5,13.7222222 L7.77777778,13.7222222 L7.77777778,23 L12.2222222,23 L12.2222222,13.7222222 L21.5,13.7222222 L21.5,9.27777778 L12.2222222,9.27777778 Z"/>
                </g>
            </svg>
        );
    }
}
